import { useEffect, useState } from "react";
import { inventoryActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";
import useInfiniteScroll from "hooks/useInfinteScroll";
import { uniqBy } from "lodash";

const useGetComponentList = (contentId: string) => {
    const dispatch = useAppDispatch();
    const { fetchingComponentList, fetchComponentListSuccess, fetchComponentListFailure } =
        useAppSelector((state) => state.inventory);

    const [componentList, setComponentList] = useState<{ [key: string]: any }[]>([]);
    const [date, setDate] = useState<{ startDate: string; endDate: string }>({
        startDate: "",
        endDate: "",
    });
    const [warehouseId, setWarehouseId] = useState<string>("");
    const [pagination, setPagination] = useState<{ currentPage: string; noOfPages: string }>({
        currentPage: "1",
        noOfPages: "",
    });

    const { updatedLimit, isLoadingMore, setLoadMore, updatedPage, setUpdatedPage } =
        useInfiniteScroll(
            { current: pagination.currentPage, number_of_pages: pagination.noOfPages },
            10,
            document.getElementById(contentId)
        );

    useEffect(() => {
        setUpdatedPage(1);
    }, [warehouseId, date]);

    useEffect(() => {
        if (date?.startDate && date?.endDate) {
            dispatch(
                inventoryActions.fetchComponentList(
                    updatedPage,
                    10,
                    warehouseId,
                    date?.startDate,
                    date?.endDate
                )
            );
        }
    }, [dispatch, warehouseId, date, updatedPage]);

    useEffect(() => {
        if (Boolean(fetchComponentListSuccess)) {
            setComponentList((prev) =>
                updatedPage === 1
                    ? [...fetchComponentListSuccess?.inventory?.data]
                    : [...prev, ...fetchComponentListSuccess?.inventory?.data]
            );

            setPagination({
                currentPage: fetchComponentListSuccess.pagination?.current,
                noOfPages: fetchComponentListSuccess.pagination?.number_of_pages,
            });
            setLoadMore(false);
            dispatch(inventoryActions.resetFetchComponentList());
        }
    }, [fetchComponentListSuccess]);

    return {
        isFetching: fetchingComponentList,
        error: fetchComponentListFailure,
        data: componentList,
        setWarehouseId,
        setDate,
        pagination,
        isLoadingMore,
        warehouseId,
        date,
        updatedPage,
    };
};

export default useGetComponentList;
